import { useCookies } from '@dtx-company/true-common/src/utils/cookies/cookies.hooks'
import { useIsEU } from './useCheckEU'

export function useCanWriteToBrowserStorage(): boolean {
  const { optOut } = useCookies()
  const { isEU, isEULoaded } = useIsEU()
  const canWriteToBrowserStorage = isEULoaded && (!optOut || !isEU)
  return canWriteToBrowserStorage
}
